import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { KeyRound, Loader2, Eye, EyeOff } from "lucide-react";

// Emergency quit password a proctor types into Safe Exam Browser to release a stuck candidate.
export function SebQuitPassword({ jobId, isSet, onChange }) {
  const [pw, setPw] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const save = async (password) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/jobs/${jobId}/seb-quit-password`, { password });
      onChange(data.seb_quit_password_set); setPw("");
      toast.success(data.seb_quit_password_set ? "Quit password saved. It applies to tests opened from now on." : "Quit password removed");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-5 rounded-xl border border-border p-4 space-y-3" data-testid="seb-quit-password">
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-start gap-2"><KeyRound className="h-4 w-4 text-primary mt-0.5" />
          <div><div className="text-sm font-medium">Emergency quit password</div>
            <div className="text-[11px] text-muted-foreground">A proctor types it into Safe Exam Browser's quit button to release a stuck candidate. Without it, candidates can only leave by submitting.</div></div></div>
        <span className={`text-[11px] px-2 py-0.5 rounded-full shrink-0 ${isSet ? "bg-emerald-500/15 text-emerald-300" : "bg-muted text-muted-foreground"}`} data-testid="seb-quit-status">{isSet ? "Set" : "Not set"}</span>
      </div>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Input type={show ? "text" : "password"} value={pw} onChange={(e) => setPw(e.target.value)} placeholder={isSet ? "Type a new password to replace it" : "At least 8 characters"} className="h-9 pr-9" data-testid="seb-quit-input" autoComplete="new-password" />
          <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground" aria-label={show ? "Hide password" : "Show password"} data-testid="seb-quit-show">{show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}</button>
        </div>
        <Button size="sm" onClick={() => save(pw)} disabled={busy || pw.trim().length < 8} data-testid="seb-quit-save">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Save"}</Button>
      </div>
      <div className="flex items-center justify-between gap-2">
        <p className="text-[11px] text-muted-foreground">Write it down and share it only with proctors. HireStream keeps just a scrambled copy and can't show it again.</p>
        {isSet && <button onClick={() => save(null)} disabled={busy} className="text-[11px] text-rose-400 hover:underline shrink-0" data-testid="seb-quit-remove">Remove</button>}
      </div>
    </div>
  );
}
